import { render, staticRenderFns } from "./Plano.vue?vue&type=template&id=fbc87ff2"
import script from "./Plano.vue?vue&type=script&lang=js"
export * from "./Plano.vue?vue&type=script&lang=js"
import style0 from "./Plano.vue?vue&type=style&index=0&id=fbc87ff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports